import { userReducer } from "./user.reducer";
import { blogReducer } from "./blog.reducer";
import { spinnerReducer } from "./spinner.reducer";

//Exporting reducers for other redux
const allReducers = {
  userReducer,
  blogReducer,
  spinnerReducer,
};

export default allReducers;
